export default __webpack_public_path__ + "static/media/categoria_caja.7c4e309a.svg";